// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"author-svg-icon_shadow__3WwTS","icon":"author-svg-icon_icon__3AHqJ"};